module.exports = __webpack_public_path__ + "img/5-1.aea2ce0a.svg";